//Copy this for easy additions
//[
// [""],
// [""],
// [""],
// [""],
// [""],
// [""],
//]

import { VERB_TENSES } from "./constants";

const cat1Habitual = [
    ["ainn"],
    ["ta", "tá"],
    ["adh"],
  
    ["ma(o)is"],
    ["adh sibh"],
    ["da(o)is"],
  
    ["ta(oi)"] //autonomous
  ];
  
  const cat2Habitual = [
    ["inn"],
    ["te", "tea", "teá"],
    ["eadh"],
  
    ["mís", "mis"],
    ["eadh sibh"],
    ["dís", "dis"],
  
    ["te/í"] //autonomous
  ];
  
  const cat1Imperative = [
    ["ar"],
    [""],
    ["adh"],
  
    ["am"],
    ["aidh"],
    ["a(i)d"],
  
    ["ta(i)r"] //autonomous
  ];
  
  const cat2Imperative = [
    ["ear"],
    [""],
    ["eadh"],
  
    ["eam"],
    ["idh"],
    ["id", "ead"],
    ["ti/ear"] //autonomous
  ];
  
  const cat1Subjunctive = [
    ["ar"],
    ["a"],
    ["a"],
    ["am"],
    ["ta(oi)"],
    ["a(i)d"],
    ["ta(i)r"] //autonomous
  ];
  
  const cat2Subjunctive = [
    ["ear"],
    ["e"],
    ["e"],
  
    ["eam"],
    ["tí", "te"],
    ["id", "ead"],
  
    ["ti/ear"] //autonomous
  ];
  
  const category1Conditional = [
    ["fainn"],
    ["faithe", "faidhe", "faithea", "faidhea", "faitheá", "faidheá"],
    ["fadh"],
  
    ["fama(o)is"],
    ["fadh sibh"],
    ["fada(o)is"],
  
    ["faith/dhe/i/í"] //autonomous
  ];
  
  const category2Conditional = [
    ["finn"],
    ["fithe", "fidhe", "fithea", "fidhea", "fitheá", "fidheá"],
    ["feadh"],
  
    ["fimis", "fimís"],
    ["feadh sibh"],
    ["fidis", "fidís"],
  
    ["fith/dhe/i/í"] //autonomous
  ];
  
  const category3Conditional = [
    ["eóchainn"],
    ["eóchtha", "eóchthá"],
    ["eóchadh"],
  
    ["eóchma(o)is"],
    ["eóchadh sibh"],
    ["eóchda(o)is"],
  
    ["eóchth(oi)"] //autonomous
  ];
  
  const category1Future = [
    ["fad"],
    ["fa", "fair*"],
    ["faidh"],
  
    ["fama(o)id"],
    ["faidhe", "faithe", "faidhí", "faithí"],
    ["faid"],
  
    ["faidh/thir", "faidh/thear"], //autonomous
    ["fas"] //relative
  ];
  
  const category1FutureDependent = [
    ["abh"],
    ["fa", "fair*"],
    ["fa"],
  
    ["fam"],
    ["faidhe", "faithe", "faidhí", "faidhí"],
    ["fad"],
  
    ["faidh/thir", "faidh/thear"], //autonomous
    ["fas"] //relative
  ];
  
  const category2Future = [
    ["fead"],
    ["fe", "fir*"],
    ["fidh"],
  
    ["fimid", "fimíd"],
    ["fidhe", "fithe", "fidhí", "fithí"],
    ["fid"],
  
    ["fidh/thir", "fidh/thear"], //autonomous
    ["feas"] //relative
  ];
  
  const category2FutureDependent = [
    ["eabh"],
    ["fe", "fir*"],
    ["fe"],
  
    ["feam"],
    ["fidhe", "fithe", "fidhí", "fithí"],
    ["fead"],
  
    ["fidh/thir", "fidh/thear"], //autonomous
    ["feas"] //relative
  ];
  
  const category3Future = [
    ["eóchad"],
    ["eócha", "eóchair*"],
    ["eóchaidh"],
  
    ["eóchma(o)id"],
    ["eóchthaoi"],
    ["eóchaid"],
  
    ["eóchtha(i)r"],
    ["eóchas"]
  ];
  
  const category3FutureDependent = [
    ["eóch"],
    ["eócha", "eóchair*"],
    ["eócha"],
  
    ["eócham"],
    ["eóchthaoi"],
    ["eóchad"],
  
    ["eóchtha(i)r"],
    ["eóchas"]
  ];
  
  const category1Present = [
    ["aim"],
    ["a(e)", "air*"],
    ["aidh"],
  
    ["ma(o)id"],
    ["aidh", "taoi"],
    ["aid"],
  
    //autonomous
    ["ta(i)r"][
      //relative
      "as"
    ]
  ];
  
  const category1PresentDependent = [
    ["aim"],
    ["a(e)", "air*"],
    ["", "ann"],
  
    ["ma(o)id", "am"],
    ["aidh", "taoi"],
    ["a(i)d"],
  
    //autonomous
    ["ta(i)r"]
  ];
  
  const category2Present = [
    ["im"],
    ["e", "ir*"],
    ["idh"],
    ["mid", "míd"],
    ["idh", "te", "tí"],
    ["id"]
  ];
  
  const category2PresentDependent = [
    ["im"],
    ["e", "ir*"],
    ["", "eann"],
    ["mid", "míd", "eam"],
    ["idh", "te", "tí"],
    ["id", "ead"]
  ];
  
  const category3Present = [
    ["im"],
    ["e"],
    ["idh"],
  
    ["mid", "míd", "eam"],
    ["te", "tí", "idh"],
    ["id", "ead"]
  ];
  
  const category1PastEndings = [
    ["as"],
    ["ais"],
    ["", "asda(i)r", "ais"],
  
    ["sam", "(s)ama(i)r"],
    ["(s)abha(i)r", "saidh"],
    ["(s)ada(i)r", "sad"],
  
    ["adh", "aid"], //passive
    ["ais"]
  ];
  
  const category2PastEndings = [
    ["eas"],
    ["is"],
    ["", "easda(i)r", "is"],
  
    ["seam", "(s)eama(i)r"],
    ["(s)eabha(i)r", "sidh"],
    [
      // "eada(i)r",
      "seada(i)r",
      "sead"
    ],
  
    ["eadh"],
    ["is"]
  ];
  
  const category3PastEndings = [
    ["eas"],
    ["is"],
    ["", "easda(i)r", "is"],
  
    ["(s)eama(i)r", "seam"],
    ["(s)eabha(i)r", "sidh"],
    ["(s)eada(i)r", "sead"],
  
    ["is"],
    ["eadh", "id"]
  ];
  
  const category1PastDependent = [
    ["as"],
    ["ais"],
    ["", "asda(i)r"],
  
    ["sam", "(s)ama(i)r"],
    ["(s)abha(i)r", "saidh"],
    ["(s)ada(i)r", "sad"],
  
    ["adh", "aid"], //passive
    ["ais"]
  ];
  
  const category2PastDependent = [
    ["eas"],
    ["is"],
    ["", "easda(i)r"],
  
    ["seam", "(s)eama(i)r"],
    ["(s)eabha(i)r", "sidh"],
    [
      // "eada(i)r",
      "seada(i)r",
      "sead"
    ],
  
    ["eadh"],
    ["is"]
  ];
  
  const category3PastDependent = [
    ["eas"],
    ["is"],
    ["", "easda(i)r"],
  
    ["(s)eama(i)r", "seam"],
    ["(s)eabha(i)r", "sidh"],
    ["(s)eada(i)r", "sead"],
  
    ["is"],
    ["eadh", "id"]
  ];
  
  const pastEndingsByCategory = [
    category1PastEndings,
    category2PastEndings,
    category3PastEndings,
    category3PastEndings
  ];
  
  const pastDependentEndings = [
    category1PastDependent,
    category2PastDependent,
    category3PastDependent,
    category3PastDependent
  ];
  
  const presentEndingsByCategory = [
    category1Present,
    category2Present,
    category2Present,
    category2Present
  ];
  
  const presentEndingsDependent = [
    category1PresentDependent,
    category2PresentDependent,
    category2PresentDependent,
    category2PresentDependent
  ];
  
  const futureEndingsByCategory = [
    category1Future,
    category2Future,
    category3Future,
    category3Future
  ];
  
  const futureEndingsDependent = [
    category1FutureDependent,
    category2FutureDependent,
    category3FutureDependent,
    category3FutureDependent
  ];
  
  const conditionalEndingsByCategory = [
    category1Conditional,
    category2Conditional,
    category3Conditional,
    category3Conditional
  ];
  const subjunctiveEndingsByCategory = [
    cat1Subjunctive,
    cat2Subjunctive,
    cat2Subjunctive,
    cat2Subjunctive
  ];
  const imperativeEndingsByCategory = [
    cat1Imperative,
    cat2Imperative,
    cat2Imperative,
    cat2Imperative
  ];
  const habitualEndingsByCategory = [
    cat1Habitual,
    cat2Habitual,
    cat2Habitual,
    cat2Habitual
  ];

const mapping = [
  {
    tense: VERB_TENSES.past,
    independent: pastEndingsByCategory,
    dependent: pastDependentEndings,
  },
  {
    tense: VERB_TENSES.present,
    independent: presentEndingsByCategory,
    dependent: presentEndingsDependent,
  },
  {
    tense: VERB_TENSES.future,
    independent: futureEndingsByCategory,
    dependent: futureEndingsDependent,
  },
  {
    tense: VERB_TENSES.conditional,
    independent: conditionalEndingsByCategory,
    dependent: conditionalEndingsByCategory,
  },
  {
    tense: VERB_TENSES.subjunctive,
    independent: subjunctiveEndingsByCategory,
    dependent: subjunctiveEndingsByCategory,
  },
  {
    tense: VERB_TENSES.habitual,
    independent: habitualEndingsByCategory,
    dependent: habitualEndingsByCategory,
  },
  {
    tense: VERB_TENSES.imperative,
    independent: imperativeEndingsByCategory,
    dependent: imperativeEndingsByCategory,
  },
]

  export {mapping,pastEndingsByCategory, pastDependentEndings, presentEndingsByCategory, presentEndingsDependent, futureEndingsByCategory,futureEndingsDependent,conditionalEndingsByCategory,subjunctiveEndingsByCategory,imperativeEndingsByCategory ,habitualEndingsByCategory}